import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock } from 'lucide-react';
export function ContactCTA() {
  return <section id="contact" className="py-24 px-6 relative overflow-hidden" data-id="element-38">
      <img src="https://cdn.magicpatterns.com/uploads/vhF5iuQKE9t7HTNfWJGNNw/banner_definitivo_4.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" data-id="element-39" />
      <div className="absolute inset-0 bg-rotterdam-black/35" data-id="element-40" />
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-rotterdam-gold to-transparent opacity-20 pearl-bg" data-id="element-41" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-4xl md:text-6xl font-serif font-bold mb-8" data-id="element-43">
          Tu turno te espera
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12 text-rotterdam-cream/90" data-id="element-44">
          <div className="flex flex-col items-center gap-3" data-id="element-45">
            <MapPin className="w-6 h-6 text-rotterdam-gold pearl-icon" data-id="element-46" />
            <span data-id="element-47">
              Av. Ovidio Lagos 1035
              <br data-id="element-48" />
              Rosario, Santa Fe
            </span>
          </div>
          <div className="hidden md:block w-px h-16 bg-rotterdam-border" data-id="element-49" />
          <div className="flex flex-col items-center gap-3" data-id="element-50">
            <Clock className="w-6 h-6 text-rotterdam-gold pearl-icon" data-id="element-51" />
            <span className="text-center" data-id="element-52">
              Lun-Vie: 10:00 – 19:30
              <br data-id="element-53" />
              Sáb: 10:00 – 14:00
              <br data-id="element-54" />
              Dom: Cerrado
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-55">
          <motion.a href="https://wa.link/ybqcdw" target="_blank" rel="noopener noreferrer" animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block px-10 py-5 bg-rotterdam-gold pearl-bg text-rotterdam-black font-bold text-lg rounded-full hover:opacity-90 transition-opacity duration-300 shadow-[0_0_30px_rgba(107,184,212,0.15)] hover:shadow-[0_0_40px_rgba(107,184,212,0.3)]" data-id="element-56">
            Reserva hoy
          </motion.a>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-16 text-rotterdam-gray font-serif italic text-xl" data-id="element-57">
          Un corte. Una experiencia. Un lugar que no vas a querer cambiar.
        </motion.p>
      </div>
    </section>;
}